<template>
  <div class="search-bar">
    <ul class="search-header">
      <li @click="switchNav('addressType')"
          :class="{active: type === 'addressType'}" name="o2o_zhaomendian_quyu_01">
        <span>{{navAddressTitle}}</span>
        <!--<i></i>-->
      </li>
      <li @click="switchNav('storeType')"
          :class="{active: type === 'storeType'}" name="o2o_zhaomendian_leixing_01">
        <span>{{navStoreTitle}}</span>
        <!--<i></i>-->
      </li>
    </ul>

    <!--选择地址-->
    <div class="address-type" v-show="type === 'addressType'" @click="hide">
      <div class="at-left">
        <div @click="switchAddress('tradingArea')"
             :class="{active: address.selectType === 'tradingArea'}">商圈
        </div>
        <div @click="switchAddress('area')"
             :class="{active: address.selectType === 'area'}">区域
        </div>
      </div>
      <div class="at-right">
        <ul>
          <li v-for="item in address[address.selectType]['items']"
              :class="{active: item[address.fieldName] === address[address.selectType]['selectItem']}"
              @click="selectAddress(item[address.fieldName], item[address.fieldValue])">
            {{item[address.fieldValue]}}
          </li>
        </ul>
      </div>
    </div>

    <!--选择门店-->
    <div class="store-type" v-show="type === 'storeType'" @click="hide">
      <ul>
        <li v-for="item in storeType.items" @click="selectStore(item.parameterId, item.parameterName)"
            :class="{active: item.parameterId === storeType.selectCode}" :name="item.sa">{{item.parameterName}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

  import Server from '../../services/Entrance';

  import _ from 'lodash';

  export default {
    name: 'SearchStoreBar',
    props: {
    	cityCode:{
        type: String
      }
    },
    data () {
      return {
        type: '',
        navAddressTitle: '全部区域',
        navStoreTitle: '全部类型',
        storeType: {
          selectCode: "",
          items: []
        },
        address: {
          selectType: "tradingArea",
          fieldName: "areaId", // cityLesId
          fieldValue: "areaName", // name
          tradingArea: {
            selectItem: "",
            items: []
          },
          area: {
            selectItem: "",
            items: []
          }
        }
      }
    },
    methods: {

      // updateAddress
      updateAddress (type) {

        let _this = this;

        if (type === "tradingArea") {

          // 查商圈
          Server.common.queryTradingArea(_this.cityCode).then(data => {
           console.log(data)
            if(data.code === '0'){
              data.data.unshift({areaId: '', areaName: '附近'});
              _this.address.tradingArea.items = data.data;
            }else {
              _this.address.tradingArea.items = [{areaId: '', areaName: '附近'}]
            }


            _this.address.fieldName = "areaId";
            _this.address.fieldValue = "areaName";

            _this.type = "addressType";
          });
        } else {

          // 查区域
          Server.common.queryDistrictByCityCode(_this.cityCode).then(data => {

            data.unshift({distNo: '', name: '全城地区'});
            _this.address.area.items = data;
            _this.address.fieldName = "cityLesId";
            _this.address.fieldValue = "name";

            _this.type = "addressType";
          });
        }
      },

      // 选择tab切
      switchNav (type) {

        let _this = this;

        // 查门店
        if (type === 'storeType') {

          if (_this.storeType.items.length > 0) {

            _this.type = _this.type === type ? "" : type;
          } else {

            Server.common.queryParameter('1036').then(data => {

              data.unshift({parameterId: '', parameterName: '全部类型'});

              let saArr = {
                type1: 'o2o_zhaomendian_dianqi_01',
                type2: 'o2o_zhaomendian_zhiyingdian_01',
                type3: 'o2o_zhaomendian_xiaodian_01',
                type4: 'o2o_zhaomendian_chaoshi_01',
                type5: 'o2o_zhaomendian_honghaizi_01',
                type6: 'o2o_zhaomendian_suningguanchang_01',
                type7: 'o2o_zhaomendian_shenghuoguangchang_01',
                type8: 'o2o_zhaomendian_weixiu_01',
                type9: 'o2o_zhaomendian_dianqijingxuan_01',
                type10: 'o2o_zhaomendian_caifu_01',
                type11: '',
                type12: 'o2o_zhaomendian_youle_01',
                type13: 'o2o_zhaomendian_youqu_01',
                type14: 'o2o_zhaomendian_tiyu_01',
                type15: 'o2o_zhaomendian_jiwu_01'
              };

              _.forEach(data, item => {
                let storeType = item.parameterId * 1;
                if (storeType >= 1 && storeType <= 15) {
                  item.sa = saArr['type' + storeType];
                } else {
                  item.sa = '';
                }
              });

              _this.storeType.items = data;
              _this.type = _this.type === type ? "" : type;
            });
          }
        } else {
          // 查商圈
          let addressType = _this.address.selectType;

          if (_this.address[addressType].items.length > 0) {

            _this.type = _this.type === type ? "" : type;
          } else {

            _this.updateAddress(addressType);
          }

          //_this.address.selectType = "tradingArea";
        }
      },
      // 选择商圈 & 区域
      switchAddress(type) {

        let _this = this;

        this.address.selectType = type;

        _this.updateAddress(type);

      },
      // 选择项
      selectAddress(id, name) {

        // 更新选中的数据
        let selectType = this.address.selectType;

        this.navAddressTitle = name;
        this.address[selectType].selectItem = id;


        // 选择的是商圈
        if (selectType === "tradingArea") {

          this.$emit('listenChild', {cbdId: id});
        } else {

          // 选择的是区域
          this.$emit('listenChild', {districtId: id});
        }
        this.type = "";
      },
      selectStore(code, name) {

        this.navStoreTitle = name;
        this.storeType.selectCode = code;
        this.$emit('listenChild', {storeType: code});
        this.type = "";
      },
      hide(e) {

        let className = e.target.className;

        if (className === "store-type" || className === "address-type") {

          this.type = "";
        }
      }
    }
  }
</script>

<style scoped>
  .search-bar {
    top: 0;
    position: fixed;
    left: 0;
    width: 100%;
    z-index: 1;

    > ul.search-header {
      width: 100%;
      height: 86px;
      background: #fff;
      border-bottom: 2px solid #dfdfdf;
      line-height: 86px;

      li {
        width: 50%;
        height: 100%;
        float: left;
        text-align: center;

        &.active {
          color: #ff9900;
          span{
            &:after{
               border-left: 10px solid transparent;
               border-right: 10px solid transparent;
               border-bottom: 14px solid #ff9900;
               border-top: none;
               top: 38PX;
             }
          }
          i {
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 14px solid #ff9900;
            border-top: none;
            position: relative;
            top: -36px;

          }
        }
        span{
          font-size: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          max-width: 100%;
          padding: 0 10%;
          height: 100%;
          /*float: left;*/
          text-align: center;
          position:relative;
          &:after{
            content: '';
            position: absolute;
            display: inline-block;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 14px solid #999;
            border-bottom: none;
            top: 38PX;
            right: 5PX;
           }
        }
        i {
          display: inline-block;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 14px solid #999;
          border-bottom: none;
          position: relative;
          top: -32px;
          left: 5px;
        }
      }
    }
  }

  .store-type {
    width: 100%;
    top: 174px;
    z-index: 1;
    position: fixed;
    background: hsla(0, 0%, 0%, .6);
    height: calc(100% - 86px);

    ul {
      height: 700px;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 0 40px;
      background: #ffffff;
    }

    li {
      line-height: 64px;
      height: 64px;
      border-bottom: 1px solid #f7f7f7;
      font-size: 25px;
      color: #333333;
      text-align: left;

      &.active {
        color: #ff9900;
      }

    }
  }
  .address-type {
    width: 100%;
    z-index: 1;
    position: fixed;
    top: 174px;
    background: hsla(0, 0%, 0%, .6);
    display: -webkit-box;
    height: calc(100% - 86px);
    font-size: 25px;
    color: #333333;
    overflow: hidden;
    text-align: center;

    .at-left {
      height: 700px;
      background: #f2f2f2;
      -webkit-box-flex: 16;
      width: 0;

      div {
        height: 87px;
        line-height: 87px;

        &.active {
          background: #ffffff;
        }
      }
    }
    .at-right {
      -webkit-box-flex: 59;
      background: #ffffff;
      height: 700px;
      overflow-x: hidden;
      overflow-y: auto;
      text-align: left;
      width: 0;

      ul {
        height: auto;
        border: 1px solid transparent;
        padding: 0 39px;

        li {
          line-height: 64px;
          height: 64px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-bottom: 1px solid #f7f7f7;

          &:nth-last-of-type(1) {
            border-bottom: none;
          }

          &.active {
            color: #ff9900;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commons/SearchStoreBar.vue